module.exports = __webpack_public_path__ + "img/contact2.d9deb7aa.png";